import { Autocomplete, Badge, Box, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, FormGroup, Grid, IconButton, Menu, MenuItem, Popover, TextField, Tooltip } from '@mui/material';
import { CellClickedEvent, ColDef, ICellRendererParams, ValueGetterParams } from 'ag-grid-community';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { LoadMessageLogsExport, LoadOrganizations, LoadUsers, ResetMessageLogsExportMsg, UpdateMenuFlag } from '../../../actions';
import { customStringComparator } from '../../../helpers/custom-comparators';
import { setHeaderTitle } from '../../../helpers/header.helper';
import { CancelIcon, ExportIcon, MessageLogsAlertInfoIcon, MoreContactsIcon, CrossIcon, BlueDownIcon, BlueUpIcon, BurgerMenuIcon, DisableCrossIcon, EmptyStateIcon, NewInfoCircleIcon } from '../../../icon';
import { Contact, MediaModel } from '../../../models/conversations';
import { MessageLogsModel, mapToMessageLogs, mapToSecureChatMessageLogs } from '../../../models/message-logs.model';
import { PhoneNumberModel } from '../../../models/phone-number.model';
import { SettingsModel, mapToTimeZoneModel } from '../../../models/settings-model';
import { UserModel } from '../../../models/users.model';
import * as selector from "../../../selectors/selectors";
import { SettingsService } from '../../../services/SettingsService';
import { UserService } from '../../../services/UserService';
import { UtilityService } from '../../../services/UtilityService';
import ButtonComponent from '../../shared/button/button.component';
import { GridStatusLabelVariant, Tags, buttonLabels, emptyLabels, pageTitles } from '../../shared/constants';
import DateAndTimePicker from '../../shared/datetimepicker/date-timepicker.component';
import GridComponent from '../../shared/grid';
import { dateComparator } from '../../shared/grid/grid.services';
import { MessageTagRenderer } from '../../shared/grid/msgTagRendrer';
import { StatusRenderer } from '../../shared/grid/statusRenderer';
import AnimateLoader from "../../shared/loaders/animate-loader.component";
import messagsLogsLoader from "../../shared/loaders/message-logs-search-inprogress-loader.json";
import Mention from '../../shared/mentions';
import { useNavigate } from 'react-router-dom'
import { AppRoutes } from '../../routes/route.path';
import { styled } from "@mui/material/styles";
import Popper from "@mui/material/Popper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { autocompleteClasses } from "@mui/material/Autocomplete";
import InputBase from "@mui/material/InputBase";
import Avatar from '../../shared/avatar.component';
import { SecureChatMessageLogService } from '../../../services/secureChatMessageLogService';
import SecureChatMediaViewComponent from '../../shared/media/secure-chat-media-view.component';

interface Props {
    ShowAlert: boolean;
}

const SecureChatMessageLogs = (props: Props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers)
    const Settings: SettingsModel = useSelector(selector.settingsObj)
    const Users: UserModel[] = useSelector(selector.users)
    const Contacts: Contact[] = useSelector(selector.contacts)

    const [emptyMessage, setEmptyMessage] = useState<string>("There are no message logs available yet!.")
    const [ismulltiNumber, setIsMulltiNumber] = useState<boolean>(true)
    const [messageDirectionSelected, setMessageDirectionSelected] = useState<string[]>([])
    const [messageStatusSelected, setMessageStatusSelected] = useState<string[]>([])
    const [messageTypeSelected, setMessageTypeSelected] = useState<string[]>([])
    const [messageLogs, setMessageLogs] = useState<any[]>([])
    const [gridApi, setGridApi] = useState<any>(null);
    const [columnApi, setColumnApi] = useState<any>(null);
    const [openMessage, setOpenMessage] = useState<boolean>(false)
    const [selectedMessage, setSelectedMessage] = useState<string>('')
    const [selectedMedia, setSelectedMedia] = useState<any[]>()
    const [openFromNumbers, setOpenFromNumbers] = useState<boolean>(false)
    const [selectedGridToNumbers, setSelectedGridToNumbers] = useState<string[]>()
    const [startDateTime, setStartDateTime] = useState<number>(-1)
    const [endDateTime, setEndDateTime] = useState<number>(-1)
    const [isLoading, setIsloading] = useState<boolean>(false)
    const [sentBy, setSentBy] = useState<string[]>([])
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [isDownloadInprogress, setisDownloadInprogress] = useState<boolean>(false)
    const [isDownloadInitiated, setIsDownloadInitiated] = useState<boolean>(false)
    const [isDownloadDone, setIsDownloadDone] = useState<boolean>(false)
    const [isDownloadFailed, setIsDownloadFailed] = useState<boolean>(false)
    const [filterOption, setFilterOption] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorE2, setAnchorE2] = useState(null);
    const [usersOpen, setUsersOpen] = useState(false);
    const [anchorUserEl, setAnchorUserEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? "custom-autocomplete" : undefined;
    const [filteredUsers, setFilteredUsers] = useState(Users);
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [anchorE3, setAnchorE3] = useState(null);
    const [anchorE4, setAnchorE4] = useState(null);
    const [inputValueFrom, setInputValueFrom] = useState('');
    const [inputValueTo, setInputValueTo] = useState('');
    const totalSelectedCountSentBy = selectedUsers.length;
    const totalSelectedCountFilters = messageDirectionSelected.length + messageStatusSelected.length + messageTypeSelected.length;
    const mobileviewFiltersSelected = selectedUsers.length + messageDirectionSelected.length + messageStatusSelected.length + messageTypeSelected.length;

    const MessageDirectionTypes = [
        { Value: "Outbound" },
        { Value: "Inbound" },
    ];

    const handleDirectionChange = (event) => {
        const value = event.target.name;
        setMessageDirectionSelected((prev) =>
            prev.includes(value)
                ? prev.filter((item) => item !== value)
                : [...prev, value]
        );
    };

    const handleDirectionTypeSelectAll = (event) => {
        if (event.target.checked) {
            setMessageDirectionSelected(MessageDirectionTypes.map(option => option.Value));
        } else {
            setMessageDirectionSelected([]);
        }
    };

    const MessageStatusTypes = [
        { Value: "Sent" },
        { Value: "Delivered" },
        { Value: "Failed" },
        { Value: "Received" },
    ];

    const messageStatusTypes = {
        "Sent": 1,
        "Delivered": 2,
        "Failed": 3,
        "Received": 4,
    };

    const handleStatus = (event) => {
        const value = event.target.name;
        setMessageStatusSelected((prev) =>
            prev.includes(value)
                ? prev.filter((item) => item !== value)
                : [...prev, value]
        );
    };

    const handleMessageStatusSelectAll = (event) => {
        if (event.target.checked) {
            setMessageStatusSelected(MessageStatusTypes.map(option => option.Value));
        } else {
            setMessageStatusSelected([]);
        }
    };

    const handelSentBy = (event, values) => {
        let selectedUserIDs = Users.filter(user => values.includes(`${user.FirstName} ${user.LastName}`.trim())).map(user => user.ID);
        setSentBy(selectedUserIDs);
        setSelectedUsers(values);
    };

    const handleFilterToggle = (event) => {
        setAnchorE2(event.currentTarget);
        setFilterOption(prevOption => !prevOption);
        if (usersOpen) {
            setUsersOpen(false);
            setAnchorUserEl(null);
        }
    };

    const handleClick = (event) => {
        setAnchorUserEl(event.currentTarget);
        setUsersOpen(true);
        if (filterOption) {
            setFilterOption(false);
            setAnchorE2(null);
        }
    };

    const handleClose = () => {
        setMessageDirectionSelected([])
        setMessageStatusSelected([])
        setMessageTypeSelected([])
        setFilterOption(false);
        setAnchorEl(null);
        setUsersOpen(false);
        setAnchorUserEl(null);
    };

    const getInitials = (firstName, lastName) => {
        return `${firstName[0]}${lastName[0]}`.toUpperCase();
    };

    const MessageLogsColoumnDefs: ColDef[] = [
        {
            field: "FromNumber",
            headerName: "From",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.FromNumber
            },
        },
        {
            field: "ToNumber",
            headerName: "To",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.ToNumber
            },
        },
        {
            field: "SentBy",
            headerName: "Sent by",
            hide: IsMobileDevice,
            valueGetter: (params: ValueGetterParams) => {
                let name = params.data.DeliveryStatus === 4 ? Contacts.find(x => x.PhoneNumber === params.data?.ToNumber[0])?.Name : Contacts.find(x => x.PhoneNumber === params.data?.FromNumber[0])?.Name
                return !!params.data.SentBy ? params.data.SentBy : name
            },
        },
        {
            field: "DeliveryStatus",
            headerName: "Delivery status",
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const label = params.data.Direction !== "OutBound" ? "Recevied" : params.data.DeliveryStatus === 1 ? "Sending" : params.data.DeliveryStatus === 2 ? "Sent" : params.data.DeliveryStatus === 3 ? "Failed" : params.data.DeliveryStatus === 4 ? "Delivered" : "Read"

                    const variant = params.data.Direction !== "OutBound" ? GridStatusLabelVariant.Info : params.data.DeliveryStatus === 1 ? GridStatusLabelVariant.Inactive : params.data.DeliveryStatus === 2 ? GridStatusLabelVariant.Other : params.data.DeliveryStatus === 3 ? GridStatusLabelVariant.Danger : params.data.DeliveryStatus === 4 ? GridStatusLabelVariant.Active : GridStatusLabelVariant.Active;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label
                        }
                    }
                    return Status
                }
                return undefined
            },

        },
        {
            field: "Direction",
            headerName: "Direction",
            hide: IsMobileDevice,
            valueGetter: (params: ValueGetterParams) => { return params.data.Direction },
        },
        {
            field: "Message",
            headerName: "Message",
            onCellClicked: (event: CellClickedEvent) => {
                openMessageDialog(event.data.Message, event.data.Media)
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const Message = {
                        component: MessageTagRenderer,
                        params: {
                            Message: UtilityService.trimMessage(params.data.Message, 20), ShowMediaIcon: !!params.data.Media
                        }
                    }
                    return Message
                }
                return undefined
            },
            comparator: customStringComparator,
            cellClass: "c-pointer"
        },
        {
            field: "TimeStamp",
            headerName: "Time stamp",
            hide: IsMobileDevice,
            valueGetter: (params: ValueGetterParams) => {
                return UtilityService.convertToDateTimeFormat(params.data.TimeStamp)
            },
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.TimeStamp, nodeB.data.TimeStamp),
            sort: 'desc',
        },
    ]

    const openToPhoneNumbersDialog = (numbers) => {
        setOpenFromNumbers(true);
        setSelectedGridToNumbers(numbers)
    }

    const closeToPhoneNumbersDialog = () => {
        setOpenFromNumbers(false);
        setSelectedGridToNumbers([])
    }

    const openMessageDialog = (message: string, media: []) => {
        setOpenMessage(true)
        setSelectedMedia(media);
        setSelectedMessage(message)
    }

    const closeMessageDialog = () => {
        setOpenMessage(false)
        setSelectedMedia(undefined);
        setSelectedMessage("")
    }

    const onGridReady = (params) => {
        setGridApi(params.api)
        setColumnApi(params.columnApi)
    }

    const getMessagePayload = () => {
        const StartDateTime = startDateTime !== -1 ? new Date(startDateTime).toISOString() : "";
        const EndDateTime = endDateTime !== -1 ? new Date(endDateTime).toISOString() : "";

        let MessageStatusSelected = messageStatusSelected.map(status => messageStatusTypes[status]);
        MessageStatusSelected = MessageStatusSelected.flat();

        const timeZone = Settings.Settings.find(x => x.Code === SettingsService.Auto_Time_Zone_Code)?.Value?.toString().toLowerCase() === "true" ? UtilityService.getDefaultTimeZone() : (Settings && Settings.Settings.length > 0 && mapToTimeZoneModel(Settings.Settings.find(x => x.Code === SettingsService.Time_Zone_Code)?.Value?.toString() || "")) || UtilityService.getDefaultTimeZone()

        let data = {
            "fromPhoneNumber": inputValueFrom.split(",").map(num => UtilityService.unmaskPhoneNumberWithPlus(num.trim())).filter(Boolean),
            "toPhoneNumber": inputValueTo.split(",").map(num => UtilityService.unmaskPhoneNumberWithPlus(num.trim())).filter(Boolean),
            "fromReceivedDateTime": StartDateTime,
            "toReceivedDateTime": EndDateTime,
            "sentBy": sentBy,
            "direction": messageDirectionSelected,
            "deliveryStatus": MessageStatusSelected,
        }
        const newData = {
            "timeZone": timeZone.Name,
            "page": 1,
            "pageSize": 10000,
        };
        for (const prop in data) {
            if (Array.isArray(data[prop]) && data[prop].length > 0) {
                newData[prop] = data[prop];
            }

            if ((typeof data[prop] === 'string' && data[prop].trim() !== '')) {
                newData[prop] = data[prop];
            }
        }
        return newData
    }

    const searchMessageLog = () => {
        setIsloading(true)
        SecureChatMessageLogService.searchMessageLogs(getMessagePayload()).then(res => {
            setIsloading(false)
            setMessageLogs(res.data.data.map(x => mapToSecureChatMessageLogs({ ...x, totalMessageLogs: res.data.totalMessageLogs })))
            if (!res.data.length) {
                setEmptyMessage("Based on your search, there are no message logs.")
            }
        }).catch(err => {
            setIsloading(false)
        })
        if (IsMobileDevice) {
            setFilterOption(false);
        }
    }

    const downloadMessagelogReport = () => {
        setisDownloadInprogress(true)
        SecureChatMessageLogService.searchMessageLogs(getMessagePayload()).then(res => {
            if (!res.data.data.length) {
                setIsDownloadInitiated(false)
                setisDownloadInprogress(false)
                setIsDownloadDone(false)
                setIsDownloadFailed(true)
            } else {
                SecureChatMessageLogService.exportMessageLogs(getMessagePayload())
                    .then(res => {
                        setIsDownloadInitiated(false)
                        setIsDownloadDone(true)

                    }).catch(err => {
                        setIsDownloadInitiated(false)
                        setisDownloadInprogress(false)
                        setIsDownloadDone(false)
                        setIsDownloadFailed(true)
                    })
            }
        })
    }

    const handleApply = () => {
        setIsLoader(true)
        setMessageDirectionSelected(messageDirectionSelected)
        setMessageStatusSelected(messageStatusSelected)
        setMessageTypeSelected(messageTypeSelected)
        setIsLoader(false)
        setFilterOption(false);
        setAnchorEl(null);
        setUsersOpen(false);
        setAnchorUserEl(null);
    }

    const clearFilters = () => {
        setMessageDirectionSelected([])
        setMessageStatusSelected([])
        setMessageTypeSelected([])
        if (IsMobileDevice) {
            setSelectedUsers([])
        }
    };

    const clearFeilds = () => {
        setStartDateTime(-1)
        setEndDateTime(-1)
        setMessageDirectionSelected([])
        setMessageStatusSelected([])
        setMessageTypeSelected([])
        setSentBy([])
        setSelectedUsers([])
        setMessageLogs([])
        setInputValueFrom('');
        setInputValueTo('');
    }

    const handleStartTimeDate = (scheduleTimeDate: number) => {
        setStartDateTime(scheduleTimeDate)
    }

    const handleEndTimeDate = (scheduleTimeDate: number) => {
        setEndDateTime(scheduleTimeDate)
    }

    const isValid = () => {
        return inputValueFrom.split(",").map(num => num.trim()).filter(Boolean)?.length || inputValueTo.split(",").map(num => num.trim()).filter(Boolean)?.length || startDateTime !== -1 || endDateTime !== -1 || messageStatusSelected?.length || messageTypeSelected?.length || messageDirectionSelected?.length || sentBy.length
    }

    useEffect(() => {
        LoadOrganizations(dispatch);
        LoadMessageLogsExport(dispatch);
        LoadUsers(dispatch)
        setHeaderTitle(pageTitles.SECURECHAT_MESSAGE_LOGS)
    }, [])


    const handleInputFrom = (e) => {
        setInputValueFrom(e.target.value);
    }

    const handleMenuFromOpen = (event) => {
        setAnchorE3(event.currentTarget);
    }

    const handleMenuFromClose = () => {
        setAnchorE3(null);
    }

    const handleKeyDownFromPhonenumbers = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            e.preventDefault();
            if (!inputValueFrom.endsWith(",")) {
                setInputValueFrom((prev) => (prev.trim() ? prev + ", " : prev));
            }
        }

        if (e.key === " " && /\d$/.test(inputValueFrom)) {
            e.preventDefault();
            setInputValueFrom((prev) => prev + ", ");
        }

        if (e.key === "Backspace") {
            setInputValueFrom((prev) => {
                if (prev.endsWith(", ")) return prev.slice(0, -2);
                if (prev.endsWith(",")) return prev.slice(0, -1);
                return prev;
            });
        }
    };

    const handleMenuFromClick = (phoneNumber: string) => {
        const maskedPhoneNumber = phoneNumber?.replace("+", "");
        const numbers = inputValueFrom.split(",").map(num => num.trim()).filter(Boolean);

        if (!numbers.includes(maskedPhoneNumber)) {
            const updatedNumbers = [...numbers, maskedPhoneNumber];
            let formatted = updatedNumbers.join(", ");
            if (!formatted.endsWith(", ")) {
                formatted += ", ";
            }
            setInputValueFrom(formatted);
        }
        handleMenuFromClose();
    };

    const handleBlurFromNumbers = () => {
        let value = inputValueFrom.trim();
        if (!value) return;
        const numbers = value.split(",").map(num => num.trim()).filter(Boolean);

        // Rejoin with consistent formatting
        let formatted = numbers.join(", ");
        if (!formatted.endsWith(",")) {
            formatted += ", ";
        }
        setInputValueFrom(formatted);
    };

    const handleInputTo = (e) => {
        setInputValueTo(e.target.value);
    }

    const handleMenuToOpen = (event) => {
        setAnchorE4(event.currentTarget);
    }

    const handleMenuToClose = () => {
        setAnchorE4(null);
    }

    const handleKeyDownToPhonenumbers = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            if (!inputValueTo.endsWith(",")) {
                setInputValueTo((prev) => (prev.trim() ? prev + ", " : prev));
            }
        }

        if (e.key === " " && /\d$/.test(inputValueFrom)) {
            e.preventDefault();
            setInputValueTo((prev) => prev + ", ");
        }

        if (e.key === "Backspace") {
            setInputValueTo((prev) => {
                if (prev.endsWith(", ")) return prev.slice(0, -2);
                if (prev.endsWith(",")) return prev.slice(0, -1);
                return prev;
            });
        }
    }

    const handleMenuToClick = (phoneNumber) => {
        const maskedPhoneNumber = phoneNumber?.replace("+", "");
        const numbers = inputValueTo.split(",").map(num => num.trim()).filter(Boolean);

        if (!numbers.includes(maskedPhoneNumber)) {
            const updatedNumbers = [...numbers, maskedPhoneNumber];
            let formatted = updatedNumbers.join(", ");
            if (!formatted.endsWith(", ")) {
                formatted += ", ";
            }
            setInputValueTo(formatted);
        }
        handleMenuToClose();
    }

    const handleBlurToPhonenumbers = () => {
        let value = inputValueTo.trim();
        if (!value) return;
        const numbers = value.split(",").map(num => num.trim()).filter(Boolean);

        // Rejoin with consistent formatting
        let formatted = numbers.join(", ");
        if (!formatted.endsWith(",")) {
            formatted += ", ";
        }
        setInputValueTo(formatted);
    }

    return (
        <div className='mx-2'>
            {
                isDownloadInitiated ? <Dialog open={isDownloadInitiated}>
                    <DialogActions>
                        <Tooltip title='Close' placement='bottom-start'>
                            <CancelIcon className={"c-pointer ml-auto m-1"} onClick={() => { setIsDownloadInitiated(false) }} />
                        </Tooltip>
                    </DialogActions>
                    <DialogContent style={{ maxWidth: "400px" }}>
                        <div className='d-flex flex-direction justify-between align-center'>
                            <ExportIcon />
                            <p className='h2-semibold mb-1 mt-1'>
                                Initiate Export
                            </p>
                            <p className='t-align-center h5-regular mb-1 mt-1'>
                                Once the export process is complete, you can download the file from export section.
                            </p>
                            <p className='d-flex flex-direction-row h5-regular mb-1 mt-1 t-align-center'>
                                Note: <p className='h5-semibold m-0 t-align-center'>
                                    Upon completion, the export will be accessible in the Export History
                                    section for a duration of 14 days.
                                </p>
                            </p>
                            <ButtonComponent ButtonLabel={buttonLabels.EXPORT} Variant={isValid() && !isDownloadInprogress ? `primary-btn` : 'disabled-btn'} ClassName='px-4 mr-2' OnClick={downloadMessagelogReport} Loading={isDownloadInprogress} />
                        </div>
                    </DialogContent>
                </Dialog> : isDownloadDone ? <Dialog open={isDownloadDone}>
                    <DialogActions>
                        <Tooltip title='Close' placement='bottom-start'>
                            <CancelIcon className={"c-pointer ml-auto m-1"} onClick={() => { setIsDownloadDone(false) }} />
                        </Tooltip>
                    </DialogActions>
                    <DialogContent style={{ maxWidth: "380px" }}>
                        <div className='d-flex flex-direction justify-between align-center'>
                            <ExportIcon />
                            <p className='t-align-center h2-semibold mb-1 mt-1'>
                                Export successfull!
                            </p>
                            <p className='t-align-center h3-regular mb-1 mt-1'>
                                Your export is ready! This export will be available for the next 14 days.
                            </p>
                            <ButtonComponent ButtonLabel={buttonLabels.VIEW_EXPORT} Variant={"primary-btn"} ClassName='px-4 mr-2'
                                OnClick={() => { navigate(AppRoutes.SecureChat_ExportReport) }} />
                        </div>
                    </DialogContent>
                </Dialog> : isDownloadFailed ? <Dialog open={isDownloadFailed}>
                    <DialogActions>
                        <Tooltip title='Close' placement='bottom-start'>
                            <CancelIcon className={"c-pointer ml-auto m-1"} onClick={() => { setIsDownloadFailed(false) }} />
                        </Tooltip>
                    </DialogActions>
                    <DialogContent style={{ maxWidth: "380px" }}>
                        <div className='d-flex flex-direction justify-between align-center'>
                            <ExportIcon />
                            <p className='t-align-center h2-semibold mb-1 mt-1'>
                                Export Failed!
                            </p>
                            <p className='t-align-center h3-regular mb-1 mt-1'>
                                Your export is failed! No Message Logs are available.
                            </p>
                        </div>
                    </DialogContent>
                </Dialog> : <></>
            }
            {!IsMobileDevice && <div className={`${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-message-log-bg"} h-v-100 o-y-scroll`}>
                <div className='d-flex flex-direction'>
                    <div className={`${IsDarkMode ? "bg-color-primary-background" : "bg-color-send-msg-chip2-badge-bg"} ml-2 mt-2 mr-1 mb-2`}>
                        <div className="report-text color-conv-section-inactive mt-2" >
                            <div className='d-flex align-center w-p-96 px-3'>
                                <div className=''>Access your complete secure chat messaging history with Message Logs. Use filters to find specific conversations and streamline your messaging history analysis. Up to 10,000 records can be displayed. To view all records, please export the data.
                                </div>
                                <div className='d-flex w-p-45 justify-flex-end p-reletive' style={{ zIndex: 1000 }}>
                                    <div className='ml-2'>
                                        <div className='d-flex justify-between'>
                                            <Box>
                                                <div className='d-flex color-sidebar-highlight bg-color-groupchat-avator-icon-bg color-primary-light br-18 ml-1'>
                                                    <div className='d-flex align-items-center' onClick={handleFilterToggle}>
                                                        <div className='d-flex justify-between p-1 pl-2 c-pointer h5-semibold'>
                                                            Advanced Filters
                                                        </div>
                                                        <IconButton size="small">
                                                            {filterOption ? (<BlueUpIcon style={{ width: '12px', height: '12px' }} />) : (<BlueDownIcon style={{ width: '12px', height: '12px' }} />)}
                                                        </IconButton>
                                                        {totalSelectedCountFilters > 0 && (
                                                            <Badge color="primary" overlap="circular" classes={{ colorPrimary: "bg-color-filter-selected" }} badgeContent={totalSelectedCountFilters}></Badge>
                                                        )}
                                                    </div>
                                                </div>
                                            </Box>
                                        </div>
                                        <Popover
                                            open={filterOption}
                                            anchorEl={anchorE2}
                                            onClose={handleClose}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                        >
                                            <div className={`p-3 ${IsDarkMode ? "bg-color-sidebar-bg" : ''} `}>
                                                <div className="d-flex justify-between">
                                                    <div className="h4-semibold my-auto">Advanced Filters</div>
                                                    <div className='d-flex'>
                                                        <div className={`d-flex h4-regular c-pointer p-1 justify-center ${totalSelectedCountFilters > 0 ? 'color-sidebar-highlight' : 'color-disabled-btn'}`} onClick={clearFilters}>
                                                            {totalSelectedCountFilters > 0 ? <CrossIcon style={{ width: '21px', height: '21px' }} /> : <DisableCrossIcon style={{ width: '21px', height: '21px' }} />}
                                                            {buttonLabels.CLEAR}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className=''><Divider light /></div>
                                                <div id="modal-description" className='footnote pt-2'>
                                                    <div className='d-flex justify-between'>
                                                        <div className='d-flex flex-direction'>
                                                            <div className='d-flex'>
                                                                <span className='h5-semibold color-schedule-selected-type'>Direction</span>
                                                                <div className='d-flex align-center ml-1'>
                                                                    <Tooltip title={"Filters by direction. Outbound is messages sent from FalkonSMS to the Carrier, and Inbound is traffic received from the Carriers to FalkonSMS"} >
                                                                        <span style={{ display: 'inline-flex', alignItems: 'center', position: 'relative', bottom: '0.5px' }}>
                                                                            <NewInfoCircleIcon />
                                                                        </span>
                                                                    </Tooltip>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <FormGroup>
                                                                    <FormControlLabel classes={{ label: 'h5-regular' }}
                                                                        control={
                                                                            <Checkbox
                                                                                size='small'
                                                                                classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                                                                checked={messageDirectionSelected.length === MessageDirectionTypes.length}
                                                                                onChange={handleDirectionTypeSelectAll}
                                                                            />
                                                                        }
                                                                        label="Select All"
                                                                    />
                                                                    {MessageDirectionTypes.map(option => (
                                                                        <FormControlLabel classes={{ label: 'h5-regular' }}
                                                                            key={option.Value}
                                                                            control={
                                                                                <Checkbox
                                                                                    size='small'
                                                                                    classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                                                                    checked={messageDirectionSelected.includes(option.Value)}
                                                                                    onChange={handleDirectionChange}
                                                                                    name={option.Value}
                                                                                />
                                                                            }
                                                                            label={option.Value}
                                                                        />
                                                                    ))}
                                                                </FormGroup>
                                                            </div>
                                                        </div>
                                                        <div className='d-flex flex-direction'>
                                                            <div className='d-flex'>
                                                                <span className='h5-semibold'>Status</span>
                                                                <div className='d-flex align-center ml-1'>
                                                                    <Tooltip title={"This is the current status of the message, which is derived from the event status as the message is processed"}>
                                                                        <span style={{ display: 'inline-flex', alignItems: 'center', position: 'relative', bottom: '0.5px' }}>
                                                                            <NewInfoCircleIcon />
                                                                        </span>
                                                                    </Tooltip>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <FormGroup>
                                                                    <FormControlLabel classes={{ label: 'h5-regular' }}
                                                                        control={
                                                                            <Checkbox
                                                                                size='small'
                                                                                classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                                                                checked={messageStatusSelected.length === MessageStatusTypes.length}
                                                                                onChange={handleMessageStatusSelectAll}
                                                                            />
                                                                        }
                                                                        label="Select All"
                                                                    />
                                                                    {MessageStatusTypes.map(option => (
                                                                        <FormControlLabel classes={{ label: 'h5-regular' }}
                                                                            key={option.Value}
                                                                            control={
                                                                                <Checkbox
                                                                                    size='small'
                                                                                    classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                                                                    checked={messageStatusSelected.includes(option.Value)}
                                                                                    onChange={handleStatus}
                                                                                    name={option.Value}
                                                                                />
                                                                            }
                                                                            label={option.Value}
                                                                        />
                                                                    ))}
                                                                </FormGroup>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='px-1 d-flex mt-auto  pt-1'>
                                                    <ButtonComponent ButtonLabel='Cancel' Variant='secondary-btn-small' OnClick={handleClose} ClassName={"mr-1 ml-auto"} />
                                                    <ButtonComponent
                                                        ButtonLabel='Apply'
                                                        Variant='primary-btn-small'
                                                        OnClick={handleApply}
                                                        Loading={isLoader}
                                                        ClassName={"px-4"} />
                                                </div>
                                            </div>
                                        </Popover>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Grid container spacing={4} className='d-flex footnote pl-3 py-1' >
                            <Grid item md={2} xl={2.3} className='d-flex flex-direction auto-complete-custom-styles'>
                                <div className='d-flex'>
                                    <span className='h6-regular'>From number(s)</span>
                                    <div className='d-flex align-center ml-1 c-pointer'>
                                        <Tooltip title={"Phone Numbers used to send messages"} placement="bottom-end">
                                            <NewInfoCircleIcon />
                                        </Tooltip>
                                    </div>
                                </div>
                                <TextField
                                    size='small'
                                    variant='outlined'
                                    placeholder='+19995559999 or 99999 or +1999'
                                    value={inputValueFrom}
                                    onClick={handleMenuFromOpen}
                                    onChange={handleInputFrom}
                                    onKeyDown={handleKeyDownFromPhonenumbers}
                                    onBlur={handleBlurFromNumbers}
                                    fullWidth
                                />
                                <div className="color-conv-section-inactive mt-1" style={{ fontStyle: "italic" }}>
                                    <div>Select or enter comma-separated phone numbers</div>
                                </div>
                                <Menu
                                    anchorEl={anchorE3}
                                    open={Boolean(anchorE3)}
                                    onClose={handleMenuFromClose}
                                    style={{ height: '300px' }}
                                >
                                    {PhoneNumbers.map((phoneNumber, index) => (
                                        <MenuItem
                                            style={{ width: '202px' }}
                                            key={index}
                                            onClick={() => handleMenuFromClick(phoneNumber.PhoneNumber)}
                                        >
                                            {UtilityService.maskPhoneNumberOnLength(phoneNumber.PhoneNumber)}
                                        </MenuItem>
                                    ))}
                                </Menu>
                            </Grid>

                            {ismulltiNumber &&
                                <Grid item md={2} xl={2.3} className='d-flex flex-direction auto-complete-custom-styles'>
                                    <div className='d-flex'>
                                        <span className='h6-regular'>To number(s)</span>
                                        <div className='d-flex align-center ml-1 '>
                                            <Tooltip title={"Delivered Phone Numbers"} placement="bottom-end">
                                                <span style={{ display: 'inline-flex', alignItems: 'center', position: 'relative' }}>
                                                    <NewInfoCircleIcon />
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <>
                                        <TextField
                                            size='small'
                                            variant='outlined'
                                            placeholder='+19995559999 or 99999 or +1999'
                                            value={inputValueTo}
                                            onClick={handleMenuToOpen}
                                            onChange={handleInputTo}
                                            onKeyDown={handleKeyDownToPhonenumbers}
                                            onBlur={handleBlurToPhonenumbers}
                                            fullWidth
                                        />
                                        <div className="color-conv-section-inactive mt-1" style={{ fontStyle: "italic" }}>
                                            <div>Select or enter comma-separated phone numbers</div>
                                        </div>
                                        <Menu
                                            anchorEl={anchorE4}
                                            open={Boolean(anchorE4)}
                                            onClose={handleMenuToClose}
                                            style={{ height: '300px' }}
                                        >
                                            {PhoneNumbers.map((phoneNumber, index) => (
                                                <MenuItem
                                                    style={{ width: '202px' }}
                                                    key={index}
                                                    onClick={() => handleMenuToClick(phoneNumber.PhoneNumber)}
                                                >
                                                    {UtilityService.maskPhoneNumberOnLength(phoneNumber.PhoneNumber)}
                                                </MenuItem>
                                            ))}
                                        </Menu>
                                    </>
                                </Grid>
                            }
                            <Grid item md={2} xl={2.3} className='d-flex flex-direction'>
                                <div className='d-flex'>
                                    <span className='h6-regular'>From</span>
                                    <div className='d-flex align-center ml-1'>
                                        <Tooltip title={"Received Time"} placement="bottom-end">
                                            <span style={{ display: 'inline-flex', alignItems: 'center', position: 'relative', bottom: '1px' }}>
                                                <NewInfoCircleIcon />
                                            </span>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className='bg-color-secondary' >
                                    <DateAndTimePicker handleChange={handleStartTimeDate} DateTime={startDateTime} TextFiledMediumSize={false} MaxDate={true} ShowRestIcon={true} />
                                </div>
                                <div className="color-conv-section-inactive mt-1" style={{ fontStyle: "italic" }}>
                                    <div>Select date and time to filter data</div>
                                </div>
                            </Grid>
                            <Grid item md={2} xl={2.3} className='d-flex flex-direction'>
                                <div className='d-flex' style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className='d-flex align-center'>
                                        <span className='h6-regular mr-1'>To</span>
                                        <Tooltip title={"Received Time"} placement="bottom-end" className='h6-regular '>
                                            <span style={{ display: 'inline-flex', alignItems: 'center', position: 'relative', bottom: '0.5px' }}>
                                                <NewInfoCircleIcon />
                                            </span>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className='bg-color-secondary' >
                                    <DateAndTimePicker handleChange={handleEndTimeDate} DateTime={endDateTime} TextFiledMediumSize={false} MaxDate={true} ShowRestIcon={true} />
                                </div>
                                <div className="color-conv-section-inactive mt-1" style={{ fontStyle: "italic" }}>
                                    <div>Select date and time to filter data</div>
                                </div>
                            </Grid>
                            <Grid item md={2} xl={2.6} className='d-flex  align-center'>
                                {/* <div className='d-flex justify-around'> */}
                                <div className='d-flex ml-1 '>
                                    <ButtonComponent
                                        ButtonLabel={buttonLabels.SEARCH}
                                        Variant={isValid() && !isDownloadInprogress ? `primary-btn` : 'disabled-btn'}
                                        OnClick={searchMessageLog}
                                        ClassName={`px-2`}
                                    />
                                </div>
                                <div className='d-flex ml-1 '>
                                    <ButtonComponent
                                        ButtonLabel={buttonLabels.EXPORT}
                                        Variant={isValid() && !isDownloadInprogress ? `primary-btn` : 'disabled-btn'}
                                        OnClick={() => { setUsersOpen(false); setIsDownloadInitiated(true) }}
                                        ClassName={`px-2`}
                                    />
                                </div>
                                <div className='d-flex ml-1 mt-2 justify-betwwen h-4'>
                                    <div className={`d-flex h4-regular c-pointer mr-1 ${isValid() ? 'color-sidebar-highlight' : 'color-disabled-btn'}`} onClick={clearFeilds}>
                                        {isValid() ? <CrossIcon style={{ width: '21px', height: '21px' }} /> : <DisableCrossIcon style={{ width: '21px', height: '21px' }} />}
                                        {buttonLabels.CLEAR}
                                    </div>
                                </div>
                                {/* </div> */}
                            </Grid>
                        </Grid>
                    </div>
                    <Grid className='d-flex justify-between align-center mr-1 ml-2 h4-medium'>
                        <div className='color-message-logs-moreLogs-info'>
                            {messageLogs[0]?.TotalMessageLogs > 10000 &&
                                <span className='d-flex align-center'>
                                    <MessageLogsAlertInfoIcon className={"mr-1"} />
                                    <span>"Your search returned more than 10,000 records . Only the first 10,000 are being displayed"
                                    </span>
                                </span>
                            }
                        </div>
                    </Grid>

                    {!messageLogs?.length && !isLoading ?
                        <div className={` ${IsDarkMode ? "bg-color-primary-background" : "bg-color-secondary"} br-2 mr-1 ml-2 t-align-center d-flex flex-direction justify-center h4-regular h-v-63`}>
                            <span ><EmptyStateIcon /></span>
                            <span className={"empty-label h5-regular"}>{emptyLabels.SECURECHAT_MESSAGELOGS}</span>
                        </div>
                        :
                        isLoading ?
                            <div className={`d-flex justify-center align-center ${IsDarkMode ? "bg-color-primary-background" : "bg-color-secondary"} my-auto h-v-62 mr-1 ml-2 o-x-hidden`}>
                                <AnimateLoader LoaderAnimation={messagsLogsLoader} className='w-20' />
                            </div>
                            :
                            <div className={"h-v-64"}>
                                <GridComponent
                                    ColumnDefs={MessageLogsColoumnDefs}
                                    RowData={messageLogs}
                                    OnGridReady={onGridReady}
                                    IsPaginationEnabled={false}
                                    gridApi={gridApi}
                                    LockVisible={true}
                                    EmptyLabel={emptyLabels.SECURECHAT_MESSAGELOGS} />
                            </div>
                    }
                </div>
            </div>}
            {
                <Dialog
                    maxWidth="sm"
                    fullWidth={true}
                    BackdropProps={{ style: { backgroundColor: "transparent" } }}
                    open={openMessage}
                    onClose={() => closeMessageDialog()}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    classes={{ paper: "br-2 w-p-40 max-w-70 dialogue-shadow" }}
                    disableEscapeKeyDown
                >
                    <DialogTitle >
                        <div className='d-flex justify-between align-center'>
                            <span className='d-flex align-center color-message-log-Dialog-title h2-medium'>
                                Message
                            </span>
                            <CancelIcon onClick={() => closeMessageDialog()} className="c-pointer" />
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <div className='h5-medium'>
                            {!!selectedMessage && <Mention body={selectedMessage} tags={Tags} emoji={''} openTags={false} tagTarget={undefined} onChange={() => { }} onKeyDown={() => { }} closeTags={() => { }} maxLength={selectedMessage.length} id={''} placeholder={''} readOnly={true} IsLinkAllowed={true} IsOutbound={true} />
                            }
                            {!!selectedMedia?.length && <div className='mt-1'><SecureChatMediaViewComponent Media={selectedMedia} classname={"display-media"} /> </div>}
                        </div>
                    </DialogContent>
                </Dialog>
            }

            {
                <Dialog
                    maxWidth="sm"
                    fullWidth={true}
                    BackdropProps={{ style: { backgroundColor: "transparent" } }}
                    open={openFromNumbers}
                    onClose={() => closeToPhoneNumbersDialog()}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    classes={{ paper: "br-2 w-p-40 dialogue-shadow" }}
                    disableEscapeKeyDown
                >
                    <DialogTitle >
                        <div className='d-flex justify-between align-center'>
                            <span className='d-flex align-center h2-medium color-message-log-Dialog-title'>
                                Group contacts
                            </span>
                            <CancelIcon onClick={() => closeToPhoneNumbersDialog()} className="c-pointer" />
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <div className='h5-medium'>
                            {selectedGridToNumbers?.map(x =>
                                <div className='p-1'>
                                    {
                                        UtilityService.maskPhoneNumberOnLength(x)
                                    }
                                </div>
                            )}
                        </div>
                    </DialogContent>
                </Dialog>
            }
            {IsMobileDevice && (
                <>
                    <div className="d-flex justify-between align-center">
                        <div className="d-flex">
                            <span className="ml-1 my-1 h1">
                                <BurgerMenuIcon
                                    className="mr-1"
                                    onClick={(e) => { e.stopPropagation(); UpdateMenuFlag(dispatch, true); }}
                                    style={{ marginTop: "0.25rem" }}
                                />
                            </span>
                            <span className="my-auto h1">Message Logs</span>
                        </div>
                        <div className="mr-1" style={{ display: 'flex', justifyContent: 'right' }}>
                            <div className='d-flex justify-between'>
                                <Box >
                                    <div className='d-flex color-sidebar-highlight bg-color-groupchat-avator-icon-bg color-primary-light br-18 ml-1'>
                                        <div className='d-flex align-items-center'>
                                            <div className=' ml-2 c-pointer mr-1 h5-semibold d-flex justify-between' onClick={handleFilterToggle}>
                                                Advanced Filters
                                            </div>
                                            <IconButton onClick={handleFilterToggle} size="small">
                                                {filterOption ? (<BlueUpIcon className='mr-1' style={{ width: '12px', height: '12px' }} />) : (<BlueDownIcon className='mr-1' style={{ width: '12px', height: '12px' }} />)}
                                            </IconButton>
                                            {mobileviewFiltersSelected > 0 && (
                                                <Badge color="primary" overlap="circular" classes={{ colorPrimary: "bg-color-filter-selected" }} badgeContent={mobileviewFiltersSelected}></Badge>
                                            )}
                                        </div>
                                    </div>
                                </Box>
                            </div>
                            <Popover
                                open={filterOption}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                sx={{
                                    marginTop: 4
                                }}
                                className='bg-color-sidebar-bg'
                            >
                                <div className='p-3'>
                                    <div className="d-flex justify-between">
                                        <div className="h4-semibold my-auto">Advanced Filters</div>
                                        <div className='d-flex'>
                                            <div className={`d-flex h4-regular c-pointer p-1 ${mobileviewFiltersSelected > 0 ? 'color-sidebar-highlight' : 'color-disabled-btn'}`} onClick={clearFilters} style={{ justifyContent: 'center' }}>
                                                {mobileviewFiltersSelected > 0 ? <CrossIcon style={{ width: '21px', height: '21px' }} /> : <DisableCrossIcon style={{ width: '21px', height: '21px' }} />}
                                                {buttonLabels.CLEAR}
                                            </div>
                                        </div>
                                    </div>
                                    <div className=''><Divider light /></div>
                                    <div>
                                        <div className="d-flex">
                                            <span className="h5-regular mt-2">Sent by</span>
                                            <div className="d-flex align-center ml-1">
                                                <Tooltip title="Users sent by message" placement="bottom-end">
                                                    <span style={{ display: 'inline-flex', alignItems: 'center', position: 'relative', top: '6px' }}>
                                                        <NewInfoCircleIcon />
                                                    </span>
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <Autocomplete
                                            disableCloseOnSelect
                                            multiple
                                            limitTags={1}
                                            id="combo-box-demo"
                                            className="bg-color-secondary"
                                            options={filteredUsers.map(x => `${x.FirstName} ${x.LastName}`)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label=""
                                                    variant="outlined"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        style: {
                                                            display: 'flex',
                                                            flexWrap: 'nowrap',
                                                            overflowX: 'auto',
                                                            whiteSpace: 'nowrap',
                                                            alignItems: 'center',
                                                            padding: '7px 5px',
                                                        },
                                                    }}
                                                />
                                            )}
                                            onChange={handelSentBy}
                                            value={selectedUsers}
                                            renderTags={(value) => (
                                                <span className="h4-regular" style={{ display: 'inline-block', overflowX: 'auto', whiteSpace: 'nowrap', maxWidth: '65%', padding: '0 4px' }}>
                                                    {value.map(x => UtilityService.trimMessage(x, 20)).join(', ')}
                                                </span>
                                            )}
                                            renderOption={(props, option, { selected }) => {
                                                const [firstName, lastName] = option.split(' ');
                                                return (
                                                    <li {...props} className='h4-regular d-flex align-center'>
                                                        <Checkbox checked={selected} classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }} />
                                                        <Avatar Name={getInitials(firstName, lastName)} Size={25} />
                                                        {/* <Avatar style={{ marginRight: 8, width: 25, height: 25, fontSize: '0.60rem', backgroundColor: color }}>
                                                            {getInitials(firstName, lastName)}
                                                        </Avatar> */}
                                                        <span className='ml-1'>{option}</span>
                                                    </li>
                                                )
                                            }}
                                        />
                                    </div>
                                    <div id="modal-description" className='footnote pt-2'>
                                        <div className='d-flex justify-between'>
                                            <div className='d-flex flex-direction'>
                                                <div className='d-flex'>
                                                    <span className='h5-semibold color-schedule-selected-type'>Direction</span>
                                                    <div className='d-flex align-center ml-1'>
                                                        <Tooltip title={"Message sent by directions"} placement="bottom-end">
                                                            <span style={{ display: 'inline-flex', alignItems: 'center', position: 'relative', }}>
                                                                <NewInfoCircleIcon />
                                                            </span>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                                <div>
                                                    <FormGroup>
                                                        {MessageDirectionTypes.map(option => (
                                                            <FormControlLabel classes={{ label: 'h5-regular' }}
                                                                key={option.Value}
                                                                control={
                                                                    <Checkbox
                                                                        size='small'
                                                                        classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                                                        checked={messageDirectionSelected.includes(option.Value)}
                                                                        onChange={handleDirectionChange}
                                                                        name={option.Value}
                                                                    />
                                                                }
                                                                label={option.Value}
                                                            />
                                                        ))}
                                                    </FormGroup>
                                                </div>
                                            </div>
                                            <div className='d-flex flex-direction ml-2'>
                                                <div className='d-flex'>
                                                    <span className='h5-semibold'>Status</span>
                                                    <div className='d-flex align-center ml-1'>
                                                        <Tooltip title={"Type of messages"} placement="bottom-end">
                                                            <span style={{ display: 'inline-flex', alignItems: 'center', position: 'relative', }}>
                                                                <NewInfoCircleIcon />
                                                            </span>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                                <div>
                                                    <FormGroup>
                                                        {MessageStatusTypes.map(option => (
                                                            <FormControlLabel classes={{ label: 'h5-regular' }}
                                                                key={option.Value}
                                                                control={
                                                                    <Checkbox
                                                                        size='small'
                                                                        classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                                                        checked={messageStatusSelected.includes(option.Value)}
                                                                        onChange={handleStatus}
                                                                        name={option.Value}
                                                                    />
                                                                }
                                                                label={option.Value}
                                                            />
                                                        ))}
                                                    </FormGroup>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex m-1 mt-auto pt-2">
                                        <ButtonComponent OnClick={handleClose} ButtonLabel={buttonLabels.CANCEL} ClassName={"mr-1 ml-auto"} Variant={"secondary-btn-small"} />
                                        <ButtonComponent OnClick={searchMessageLog} ButtonLabel={buttonLabels.SEARCH} Loading={isLoading} ClassName={"px-4"} Variant={isValid() && !isDownloadInprogress ? `primary-btn-small` : 'disabled-btn-small'} />
                                    </div>
                                </div>
                            </Popover>
                        </div>
                    </div>
                    <div className="d-flex flex-direction auto-complete-custom-styles">
                        <div className="d-flex">
                            <span className="h5-regular mt-1 ml-1">From number(s)</span>
                            <div className="d-flex align-center ml-1">
                                <Tooltip title="PhoneNumbers used to sent message" placement="bottom-end">
                                    <span style={{ display: 'inline-flex', alignItems: 'center', position: 'relative', top: '2px' }}>
                                        <NewInfoCircleIcon />
                                    </span>
                                </Tooltip>
                            </div>
                        </div>
                        <>
                            <TextField
                                size='small'
                                variant='outlined'
                                placeholder='+19995559999 or 99999 or +1999'
                                value={inputValueFrom}
                                onClick={handleMenuFromOpen}
                                onChange={handleInputFrom}
                                // onKeyDown={handleKeyDownFromPhonenumbers}
                                onBlur={handleBlurFromNumbers}
                                fullWidth
                                InputProps={{
                                    style: {
                                        display: 'flex',
                                        flexWrap: 'nowrap',
                                        overflowX: 'auto',
                                        whiteSpace: 'nowrap',
                                        alignItems: 'center',
                                        padding: '4px 1px',
                                    },
                                }}
                                sx={{
                                    '& .MuiInputBase-input::placeholder': {
                                        fontSize: '0.9rem',
                                    },
                                }}
                            />
                            <Menu
                                anchorEl={anchorE3}
                                open={Boolean(anchorE3)}
                                onClose={handleMenuFromClose}
                                style={{ height: '300px' }}
                            >
                                {PhoneNumbers.map((phoneNumber, index) => (
                                    <MenuItem
                                        style={{ width: '202px' }}
                                        key={index}
                                        onClick={() => handleMenuFromClick(phoneNumber.PhoneNumber)}
                                    >
                                        {UtilityService.maskPhoneNumberOnLength(phoneNumber.PhoneNumber)}
                                    </MenuItem>
                                ))}
                            </Menu>
                        </>
                    </div>
                    {ismulltiNumber && (
                        <div className="d-flex flex-direction auto-complete-custom-styles">
                            <div className="d-flex">
                                <span className="h5-regular mt-3 ml-1">To number(s)</span>
                                <div className="d-flex align-center ml-1">
                                    <Tooltip title="Delivered PhoneNumbers" placement="bottom-end">
                                        <span style={{ display: 'inline-flex', alignItems: 'center', position: 'relative', top: '10px' }}>
                                            <NewInfoCircleIcon />
                                        </span>
                                    </Tooltip>
                                </div>
                            </div>
                            <>
                                <TextField
                                    size='small'
                                    variant='outlined'
                                    placeholder='+19995559999 or 99999 or +1999'
                                    value={inputValueTo}
                                    onClick={handleMenuToOpen}
                                    onChange={handleInputTo}
                                    onKeyDown={handleKeyDownToPhonenumbers}
                                    onBlur={handleBlurToPhonenumbers}
                                    fullWidth
                                    InputProps={{
                                        style: {
                                            display: 'flex',
                                            flexWrap: 'nowrap',
                                            overflowX: 'auto',
                                            whiteSpace: 'nowrap',
                                            alignItems: 'center',
                                            padding: '4px 1px',
                                        },
                                    }}
                                    sx={{
                                        '& .MuiInputBase-input::placeholder': {
                                            fontSize: '0.9rem',
                                        },
                                    }}
                                />
                                <Menu
                                    anchorEl={anchorE4}
                                    open={Boolean(anchorE4)}
                                    onClose={handleMenuToClose}
                                    style={{ height: '300px' }}
                                >
                                    {PhoneNumbers.map((phoneNumber, index) => (
                                        <MenuItem
                                            style={{ width: '202px' }}
                                            key={index}
                                            onClick={() => handleMenuToClick(phoneNumber.PhoneNumber)}
                                        >
                                            {UtilityService.maskPhoneNumberOnLength(phoneNumber.PhoneNumber)}
                                        </MenuItem>
                                    ))}
                                </Menu>
                            </>
                        </div>
                    )}
                    <div className="d-flex justify-between">
                        <div className="d-flex flex-direction mt-3">
                            <div className="d-flex">
                                <span className="h5-regular ml-1">From</span>
                                <div className="d-flex align-center ml-1">
                                    <Tooltip title="Received Time" placement="bottom-end">
                                        <span style={{ display: 'inline-flex', position: 'relative', }}>
                                            <NewInfoCircleIcon />
                                        </span>
                                    </Tooltip>
                                </div>
                            </div>
                            <div className="bg-color-secondary mx-1">
                                <DateAndTimePicker
                                    handleChange={handleStartTimeDate}
                                    DateTime={startDateTime}
                                    TextFiledMediumSize
                                    MaxDate
                                    ShowRestIcon
                                />
                            </div>
                        </div>
                        <div className="d-flex flex-direction">
                            <div className="d-flex justfiy-between">
                                <div className="d-flex align-center">
                                    <span className="h6-regular mr-1 mt-3">To</span>
                                    <Tooltip title="Received Time" placement="bottom-end">
                                        <span style={{ display: 'inline-flex', alignItems: 'center', position: 'relative', top: '10px' }}>
                                            <NewInfoCircleIcon />
                                        </span>
                                    </Tooltip>
                                </div>
                            </div>
                            <div className="bg-color-secondary mx-1">
                                <DateAndTimePicker
                                    handleChange={handleEndTimeDate}
                                    DateTime={endDateTime}
                                    TextFiledMediumSize
                                    MaxDate
                                    ShowRestIcon
                                />
                            </div>
                        </div>
                    </div>
                    <div className='d-flex mt-1 justify-between'>
                        <div className='d-flex ml-1' style={{ height: '72px' }}>
                            <ButtonComponent
                                ButtonLabel={buttonLabels.CLEAR}
                                Variant={isValid() && !isDownloadInprogress ? `primary-btn` : 'disabled-btn'}
                                OnClick={clearFeilds}
                                ClassName={`px-8 br-12 h4-regular`}
                            />
                        </div>
                        <div className='d-flex mr-1 h-9'>
                            <ButtonComponent
                                ButtonLabel={buttonLabels.SEARCH}
                                Variant={isValid() && !isDownloadInprogress ? `primary-btn` : 'disabled-btn'}
                                OnClick={searchMessageLog}
                                Loading={isLoading}
                                ClassName={`${isLoading ? 'px-6' : 'px-7'} br-12 h4-regular`}
                            />
                        </div>
                    </div>
                    <div className={"h-v-60 o-hidden p-relative"}>
                        <GridComponent
                            ColumnDefs={MessageLogsColoumnDefs}
                            RowData={messageLogs}
                            OnGridReady={onGridReady}
                            IsPaginationEnabled={false}
                            gridApi={gridApi}
                            LockVisible={false}
                            EmptyLabel={emptyLabels.SECURECHAT_MESSAGELOGS} />
                    </div>
                </>
            )}
        </div>
    )
}

export default SecureChatMessageLogs;